import React, { createContext, useContext } from "react"
import _ from "lodash"
import I18n from "@helper/i18nInstance"

import "./Ranking.scss"

import ArrowLink from "@ui/ArrowLink"
import Paginator from "@ui/Paginator"

export const RANKING_HOLDER_CLASS = "neo__js__quizRankingHolder"

export interface IRankingContext {
  ranking?: Ranking.Api.GetRankingResp
  toPage: (page: number) => void
}

export const RankingContext = createContext<IRankingContext>({ toPage: () => {} })
RankingContext.displayName = "RankingContext"

export const WithRanking: React.FC<React.PropsWithChildren<{ranking: Ranking.Api.GetRankingResp, toPage: (page: number) => void}>> = ({ranking, toPage, children}) => {
  return <RankingContext.Provider value={{ranking, toPage}}>
    {children}
  </RankingContext.Provider>
}

export const useRanking = () => useContext(RankingContext)

export const Ranking: React.FC<{ranking: Ranking.Api.Ranking, toPage: (page: number) => void}> = ({ ranking, toPage }) => {
  const showPaginator = _.isNumber(ranking.current_page) && _.isNumber(ranking.total_pages)

  return (
    <div className={`neo__rankingSection ${RANKING_HOLDER_CLASS}`}>
      <h2>{I18n.t("ranking.title", { title: ranking.title })}</h2>
      <table className="neo__ranking">
        <thead>
          <tr>
            <th>#</th>
            <th>{I18n.t("ranking.label_nickname")}</th>
            {_.isNumber(ranking.entries?.[0]?.score) &&
              <th>{I18n.t("ranking.label_score")}</th>}
          </tr>
        </thead>
        <tbody>
          {_.map(ranking.entries, (e, index) => {
            return (
              <tr key={index} className={`neo__ranking__entry ${e.own ? "--own" : ""}`}>
                <td className="neo__ranking_rank">{e.rank}</td>
                <td className="neo__ranking_nickname">{e.nickname}</td>
                {_.isNumber(e.score) &&
                  <td className="neo__ranking_score">{e.score}</td>}
              </tr>
            )
          })}
        </tbody>
      </table>
      {showPaginator
        ? <Paginator info={{current: ranking.current_page || 1, total: ranking.total_pages || 1}} toPage={toPage} />
        : ranking.full_ranking_url && <ArrowLink href={ranking.full_ranking_url}>{I18n.t("ranking.link_to_full_ranking")}</ArrowLink>}
    </div>
  )
}
